import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const cancelSubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CANCEL_SUBSCRIPTION_START:
      return { ...state, loading: true, error: null };
    case types.CANCEL_SUBSCRIPTION_SUCCESS:
      return { loading: false, data: action.payload, error: null };
    case types.CANCEL_SUBSCRIPTION_ERROR:
      return { ...state, loading: false, error: action.payload };
    case types.CANCEL_SUBSCRIPTION_RESET:
      return initialState;
    default:
      return state;
  }
};

export default cancelSubscriptionReducer;
